import ProgressBar from "@/components/Progress/ProgressBar";
import { useTranslation } from "react-i18next";

interface ProgressProps {
  total: number;
  completed: number;
}

function Progress({ total, completed }: ProgressProps) {
  const { t } = useTranslation();
  const percentage = Math.round((completed / total) * 100);
  return (
    <div className="inline-flex flex-col items-start justify-center gap-1">
      <div className="inline-flex items-center justify-start gap-1">
        <ProgressBar completedPercent={percentage} />
        <div className="text-right leading-tight text-gray-700">
          {percentage}%
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-0.5">
        <div>
          <span className="font-medium leading-tight text-gray-700">
            {completed}/{total}
          </span>
          <span className="leading-tight text-gray-700"> </span>
          <span className="leading-tight text-gray-600">
            {t("items-completed")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Progress;
